let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a4ATO")).then(() => parcelRequire('i6a9a'));